<div class="container">
  @if (userService.getUserStatus()) {
    <div class="input-area">
      <form class="form" [formGroup]="dataForm" (ngSubmit)="onSubmit()">
        <p>Rapportér annonce*</p>
        <mat-form-field class="rating-form-field" appearance="outline">
          <textarea
            formControlName="report"
            placeholder="Din feedback er vigtig for os! Del din mening."
            name="text"
            matInput
            rows="5"
            required></textarea>
        </mat-form-field>
        <div class="action">
          <button mat-button class="btn-submit sub-btn" type="submit">
            Indsend
          </button>
          <button mat-button class="btn-submit clear-btn" mat-dialog-close>
            Annuller
          </button>
        </div>
      </form>
    </div>
  }

  @if (!userService.getUserStatus()) {
    <div class="login-card">
      <button
        mat-button
        mat-dialog-close
        class="btn-submit sub-btn"
        type="button"
        [routerLink]="['/login']">
        Log ind
      </button>
      <p>Du skal være logget ind for at indsende en anmeldelse.</p>
    </div>
  }
</div>
